<template>
  <div class="files-list-card" :style="`maxHeight:${height}`">
    <el-row v-if="data.length>0" :gutter="12">
      <el-col v-for="item in data" :key="item.path" :xs="12" :sm="8" :md="6" :lg="4" :xl="3">
        <el-card class="file-page-container card-item" shadow="hover" :class="{'searched-card-item':item.name===name||latestUploadFiles.includes(item.path)}">
          <div class="card-item-header" :class="{'opacity-0':item.isDirectory}">
            <el-dropdown v-show="!item.isDirectory" trigger="click" placement="bottom-start" size="small">
              <span class="el-dropdown-link">
                <i class="el-icon-more card-more-icon"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="item.isImg" icon="el-icon-picture-outline-round" v-clipboard:copy="item.path+'?imageMogr2/format/webp'" v-clipboard:success="onCopy">webp格式</el-dropdown-item>
                <el-dropdown-item icon="el-icon-view" @click.native="showFileDetail(item)">查看详情</el-dropdown-item>
                <el-dropdown-item v-if="userInfo.isAdmin" icon="el-icon-delete" @click.native="deleteFile(item)">删除文件</el-dropdown-item>
                <el-dropdown-item v-if="item.isImg" icon="el-icon-crop" @click.native="imageHandle(item)">图片处理</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="card-item-content">
            <el-image class="file-image" v-if="item.isImg" :src="item.path" :preview-src-list="srcList" fit="contain"></el-image>
            <div v-else class="file-icon file-image" :class="`file-icon-${item.ext}`" @click="openDirectory(item)"></div>
            <p class="file-name text-overflow-ellipsis">{{item.name}}</p>
          </div>
          <div class="line-divider"></div>
          <div v-if="!item.isDirectory" class="card-item-footer">
            <div class="file-size">
              <span class="name">文件大小</span>
              <span class="size">{{getSize(item.size)}}</span>
            </div>
            <div class="file-btn">
              <el-button type="primary" size="small" plain circle icon="el-icon-document-copy" v-clipboard:copy="item.path" v-clipboard:success="onCopy"></el-button>
              <el-button type="success" size="small" plain circle icon="el-icon-download" @click="downloadFile(item)"></el-button>
            </div>
          </div>
          <div v-else class="card-item-footer">
            <el-button style="width:100%" type="primary" size="small" @click="openDirectory(item)">打开目录</el-button>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div class="empty-content" v-else>
      <p class="empty-text">一起来上传文件吧~</p>
    </div>
  </div>
</template>

<script>
import { getFileSize } from '@/common/utils/size.js';
import { mapGetters } from 'vuex';
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    height: {
      type: String,
      default: '700px'
    },
    name: {
      type: String,
      default: ''
    },
    latestUploadFiles: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['userInfo']),
    srcList () {
      const data = [];
      this.data.forEach(item => {
        if (item.isImg) {
          data.push(item.path);
        }
      })
      return data;
    }
  },
  methods: {
    // 删除文件
    deleteFile (data) {
      this.$emit('deleteFile', data)
    },
    // 显示图片处理
    imageHandle (data) {
      this.$emit('imageHandle', data)
    },
    // 显示文件详情
    showFileDetail (data) {
      this.$emit('showFileDetail', data)
    },
    // 获取文件大小
    getSize (size) {
      if (size !== '-') {
        return getFileSize(size);
      } else {
        return size;
      }
    },
    // 复制
    onCopy () {
      this.$message.success('文件地址复制成功', 2);
    },
    // 下载
    downloadFile (item) {
      this.$emit('downloadFile', item)
    },
    // 打开目录
    openDirectory (item) {
      if (item.ext === 'folder') {
        this.$emit('openDirectory', item)
      } else {
        return;
      }
    },
  }
}
</script>

<style lang="scss">
.files-list-card {
  margin-top: 20px;
  overflow: hidden;
  overflow-y: auto;
  .opacity-0 {
    height: 22px;
    opacity: 0;
  }
  .card-item {
    margin-bottom: 10px;
    height: 275px;
    border-radius: 6px;
    box-shadow: 2px 2px 2px #f4f4f4;
    &.searched-card-item {
      background-color: oldlace;
      .file-name {
        color: #fc7878;
      }
    }
    .line-divider {
      margin-bottom: 12px;
      width: 100%;
      height: 1px;
      background-color: #f1f1f1;
    }
    &-header {
      margin-bottom: 10px;
      text-align: right;
      .card-more-icon {
        transform: rotate(90deg);
      }
    }
    &-content {
      text-align: center;
    }
    &-footer {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
    }
    .file-image {
      height: 110px;
      border-radius: 4px;
    }
    .file-icon {
      width: 100%;
      height: 110px;
      background-position: center;
      background-size: contain;
    }
    .file-name {
      color: #041677;
      font-size: 12px;
      font-weight: 700;
      text-align: center;
    }
    .file-size {
      display: flex;
      flex-flow: column nowrap;
      font-size: 12px;
      .name {
        margin-bottom: 5px;
        font-weight: 700;
        color: #041677;
      }
      .size {
        font-size: 600;
        color: #adb4bf;
      }
    }
  }
  .empty-content {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: 100%;
    height: 220px;
    background-image: url("https://front-xps-cdn.xsyx.xyz/custom/xps/images/no_data.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    .empty-text {
      font-weight: 500;
      color: #bcbcbc;
    }
  }
}
</style>